import { Martini } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type AirballButtonProps = { disabled: boolean; onClick: () => void }

/** Bicchierino sul bordo della rete: apre lo sheet con entrambe le rose per registrare un airball. */
export function AirballButton({ disabled, onClick }: AirballButtonProps) {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      data-testid="airball"
      disabled={disabled}
      onClick={onClick}
      aria-label={t('admin.zambepong.match.airball')}
      title={t('admin.zambepong.match.airball')}
      className="grid size-12 place-items-center rounded-full border border-paper/25 bg-ink text-paper transition-[transform,background-color] duration-150 hover:bg-paper/10 enabled:active:scale-90 disabled:cursor-not-allowed disabled:opacity-35"
    >
      <Martini className="size-5" aria-hidden="true" />
    </button>
  )
}
